/* TLC REVIEWS v3: "How it fits" bar + fit chip highlight for the Judge.me widget.
   Reads the "Sizing" answers customers already give in their product reviews.
   The verdict is only (re)calculated from the product reviews tab in its default
   sort order, so switching to store reviews or "lowest rating" never skews it.
   Read-only: never changes Judge.me data or behaviour. */
(function () {
  var LABEL = 'sizing';
  var MIN_ANSWERS = 3;

  function norm(t) { return (t || '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  function tagAndCount(widget) {
    var counts = { small: 0, tts: 0, large: 0 };
    widget.querySelectorAll('.jm-multi-choice-answer').forEach(function (row) {
      var label = row.querySelector('.jm-text');
      if (!label || norm(label.textContent) !== LABEL) return;
      row.classList.add('tlc-fit-chip');
      var v = norm((row.querySelector('.jm-answer-item') || row).textContent);
      if (v.indexOf('small') > -1) counts.small++;
      else if (v.indexOf('large') > -1 || v.indexOf('big') > -1) counts.large++;
      else if (v.indexOf('true') > -1) counts.tts++;
    });
    return counts;
  }

  function build(c) {
    var n = c.small + c.tts + c.large;
    var pos = Math.round(((c.tts * 50) + (c.large * 100)) / n);
    var verdict = 'True to size';
    if (c.large > c.tts && c.large >= c.small) verdict = 'Runs large';
    else if (c.small > c.tts && c.small > c.large) verdict = 'Runs small';
    var note = verdict === 'True to size' ? 'Most reviewers say it fits true to size.'
      : verdict === 'Runs large' ? 'Most reviewers say it runs large. Check the size guide if you are between sizes.'
      : 'Most reviewers say it runs small. Check the size guide if you are between sizes.';
    return '<div class="tlc-fitbar__h">How it fits <span>' + verdict + '</span></div>' +
      '<div class="tlc-fitbar__scale" aria-hidden="true"><i class="tlc-fitbar__dot" style="left:' + pos + '%"></i></div>' +
      '<div class="tlc-fitbar__lbls" aria-hidden="true"><span>Runs small</span><span>True to size</span><span>Runs large</span></div>' +
      '<p class="tlc-fitbar__note">' + note + '</p>';
  }

  var state = { html: null, best: 0, initialSort: null };

  function onDefaultView(widget) {
    var tab = widget.querySelector('.jdgm-tab-dropdown__select');
    var sort = widget.querySelector('.jm-sort-filter select');
    if (sort && state.initialSort === null) state.initialSort = sort.value;
    var tabOk = !tab || tab.selectedIndex === 0;
    var sortOk = !sort || sort.value === state.initialSort;
    return tabOk && sortOk;
  }

  function render(widget) {
    var header = widget.querySelector('.jm-review-widget__header');
    if (!header) return;
    var c = tagAndCount(widget);
    var n = c.small + c.tts + c.large;
    if (onDefaultView(widget) && n >= MIN_ANSWERS && n >= state.best) {
      state.best = n;
      state.html = build(c);
    }
    if (!state.html) return;
    var bar = widget.querySelector('.tlc-fitbar');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'tlc-fitbar';
      bar.setAttribute('role', 'note');
    }
    if (bar.dataset.sig !== state.html) { bar.innerHTML = state.html; bar.dataset.sig = state.html; }
    var anchor = header.querySelector(':scope > .jm-cluster');
    if (anchor && bar.previousElementSibling !== anchor) anchor.insertAdjacentElement('afterend', bar);
  }

  function init() {
    var widget = document.querySelector('.jdgm-review-widget.jdgm-widget-revamp');
    if (!widget || !widget.querySelector('.jm-review-widget__header')) return false;
    var t;
    render(widget);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var tgt = muts[i].target;
        if (tgt.closest && tgt.closest('.tlc-fitbar')) continue;
        clearTimeout(t); t = setTimeout(function () { render(widget); }, 150); break;
      }
    }).observe(widget, { childList: true, subtree: true });
    return true;
  }

  if (!init()) {
    var tries = 0;
    var iv = setInterval(function () { if (init() || ++tries > 40) clearInterval(iv); }, 500);
  }
})();
